'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { IdpHeader } from './_layout/-components/IdpHeader';
export const Route = createFileRoute('/_staff/idp/_layout')({
  component: RouteComponent
});
function RouteComponent() {
  return <VStack className="gap-0 h-full">
      <IdpHeader />
      {/* 背景は他プロダクト（設定 > 認証 等）と同じ _staff の bottom-fill に揃える。 */}
      <div className="relative min-h-0 flex-1 overflow-auto bg-neutral-bottom-fill">
        <Outlet />
      </div>
    </VStack>;
}